function toFinite(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : NaN;
}

function normalizePair(point) {
  if (Array.isArray(point) && point.length >= 2) {
    const lat = toFinite(point[0]);
    const lon = toFinite(point[1]);
    if (Number.isFinite(lat) && Number.isFinite(lon)) return [lat, lon];
    return null;
  }
  const lat = toFinite(point?.lat ?? point?.latitude);
  const lon = toFinite(point?.lon ?? point?.lng ?? point?.longitude);
  if (Number.isFinite(lat) && Number.isFinite(lon)) return [lat, lon];
  return null;
}

export function normalizeLatLngPairs(points) {
  if (!Array.isArray(points)) return [];
  return points.map(normalizePair).filter(Boolean);
}

function targetPointsForZoom(zoom) {
  const z = Number.isFinite(Number(zoom)) ? Number(zoom) : 13;
  if (z <= 8) return 700;
  if (z <= 10) return 1300;
  if (z <= 12) return 2400;
  if (z <= 14) return 3800;
  if (z <= 16) return 6200;
  return 9000;
}

export function simplifyLatLngPairsByZoom(points, zoom, options = {}) {
  const clean = normalizeLatLngPairs(points);
  if (clean.length <= 2) return clean;
  const target = Math.max(
    200,
    Number(options?.targetPoints) || targetPointsForZoom(zoom)
  );
  if (clean.length <= target) return clean;
  const step = Math.max(1, Math.ceil(clean.length / target));
  const sampled = [clean[0]];
  for (let i = step; i < clean.length - 1; i += step) {
    sampled.push(clean[i]);
  }
  sampled.push(clean[clean.length - 1]);
  return sampled;
}

export function chunkLatLngPairs(points, chunkSize = 1800) {
  const clean = normalizeLatLngPairs(points);
  const size = Math.max(300, Number(chunkSize) || 1800);
  if (clean.length <= size) return clean;

  const out = [];
  const stride = Math.max(2, size - 1);
  for (let i = 0; i < clean.length; i += stride) {
    const start = i === 0 ? i : i - 1;
    const end = Math.min(clean.length, i + size);
    const seg = clean.slice(start, end);
    if (seg.length >= 2) out.push(seg);
  }
  return out.length === 1 ? out[0] : out;
}

export function toLeafletOptimizedPolyline(points, options = {}) {
  const simplified = simplifyLatLngPairsByZoom(points, options?.zoom, options);
  return chunkLatLngPairs(simplified, options?.chunkSize || 1800);
}

export function flattenLatLngPairs(points) {
  if (!Array.isArray(points)) return [];
  if (!Array.isArray(points[0]?.[0])) return normalizeLatLngPairs(points);
  const flat = [];
  points.forEach((segment) => {
    normalizeLatLngPairs(segment).forEach((p) => flat.push(p));
  });
  return flat;
}
